<template>
  <div class="url">
    <p class="desc" v-html="$t('journey.capture.url.heatmapDescription')"></p>
    <div class="set-url">
      <div class="radio--wrap">
        <ui-icon-tooltip arrowLeft>
          <span v-html="$t('heatmap.registration.loginCheck.tooltip')"></span>
        </ui-icon-tooltip>
        <p class="content__desc" v-html="$t('journey.capture.url.bLogin')"></p>
        <div class="label--wrap">
          <label>
            <ui-radio :value="bLogin"
                      @input="$emit('onSelectLoginAction', true)">
              {{ $t('common.yes') }}
            </ui-radio>
          </label>
          <label class="right">
            <ui-radio :value="!bLogin"
                      @input="$emit('onSelectLoginAction', false)">
              {{ $t('common.no') }}
            </ui-radio>
          </label>
        </div>
      </div>
      <div class="input--wrap" v-if="!bLogin">
        <ui-input-text :type="'text'"
                       :id="'captureUrl'"
                       :name="'captureUrl'"
                       :placeholder="isExactMatchType ? $t('heatmap.registration.urlCheck.exactPlaceholder') : $t('heatmap.registration.urlCheck.placeholder')"
                       :modelError="modelError.captureUrl"
                       :modelValue="model.captureUrl"
                       @onFocus="modelError.captureUrl = ''"
                       @input="model.captureUrl = $event">
                      {{ $t('journey.capture.url.customUrl') }}</ui-input-text>
      </div>
      <div class="image--wrap" v-else>
        <div class="note">
          <div class="title">{{ 'NOTE' }}</div>
          <div class="tag--wrap">
            <div class="tag">
              <label class="label">{{ $t('common.name') }}</label>
              <div class="input">{{ $t('common.exName') }}</div>
            </div>
            <i class="icon icon--arrow-small-right-gray"></i>
            <div class="tag right">
              <label class="label">{{ 'XX' }}</label>
              <div class="input">{{ 'XX' }}</div>
            </div>
          </div>
          <div class="desc--wrap">
            <span class="main" v-html="$t('journey.capture.captureDescription.main')"></span>
            <span class="sub" v-html="$t('journey.capture.captureDescription.sub')"></span>
          </div>
        </div>
      </div>
      <div class="radio--wrap css">
        <ui-icon-tooltip arrowLeft>
          <span v-html="$t('heatmap.journey.screenshot.csstooltip')"></span>
        </ui-icon-tooltip>
        <p class="content__desc css" v-html="$t('heatmap.registration.exclude.subject')"></p>
        <div class="label--wrap">
          <label>
            <ui-radio :value="excludeCheck"
                      @input="excludeCheckChange(true)">
              {{ $t('common.yes') }}
            </ui-radio>
          </label>
          <label class="right">
            <ui-radio :value="!excludeCheck"
                      @input="excludeCheckChange(false)">
              {{ $t('common.no') }}
            </ui-radio>
          </label>
        </div>
      </div>
      <div class="input--wrap css" v-if="excludeCheck">
        <span class="url--desc" v-html="$t('heatmap.registration.exclude.description.first')"></span>
        <ui-input-text :type="'text'"
                       :id="'captureUrl'"
                       :name="'captureUrl'"
                       :placeholder="$t('heatmap.journey.screenshot.cssPlaceholder')"
                       :modelValue="cssSelector"
                       @input="inputSelector"></ui-input-text>
      </div>
    </div>
    <!-- <div class="buttons">
      <ui-button :primary2="true"
                 :disabled="model.captureUrl.length < 1"
                 @click="$emit('onCaptureAction')">{{ $t('common.confirm') }}</ui-button>
    </div> -->
  </div>
</template>
<script>
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import UiInputText from '@/components/ui/UiInputText'
import UiRadio from '@/components/ui/UiRadio'
import { mapState } from 'vuex'

export default {
  components: {
    UiIconTooltip,
    UiInputText,
    UiRadio
  },
  props: [
    'bLogin',
    'cssSelector',
    'model',
    'modelError',
    'onCaptureAction',
    'onSelectLoginAction',
    'onSelectCssSelectorAction'
  ],
  methods: {
    inputSelector (value) {
      this.exceptionSelector = value
      this.$emit('inputSelector', this.exceptionSelector)
    },
    excludeCheckChange (val) {
      this.excludeCheck = val
      this.$emit('excludeCheckChange', val)
    },
    loginCheckChange (val) {
      this.$emit('onSelectLogin', val)
    }
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'domain'
    ]),
    isExactMatchType () {
      return this.domain.matchType === 'exact' || this.journeyOptions.matchType === 'exact'
    }
  },
  data () {
    return {
      excludeCheck: !!this.cssSelector,
      exceptionSelector: this.cssSelector
    }
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
.url {
  position: absolute;
  width: 100%;
  height: 372px;
  overflow-x: hidden;
  overflow-y: scroll;
  .desc {
    margin: 14px 0 20px 0;
    font-size: 14px;
    line-height: 1.57;
    color: #666666;
    // height: 88px;
    text-align: center;
    &/deep/ .alert {
      color: #EC0047;
      text-align: center;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
    }
  }
  .set-url {
    text-align: center;
    padding: 0 80px;
    border-top: dashed 1px #d7d7d7;
    padding-bottom: 30px;
    .radio--wrap {
      margin-top: 20px;
      vertical-align: middle;
      line-height: 22px;
      text-align: left;
      &.css {
        margin-top: 35px;
      }
      .label--wrap {
        float: right;
        position: relative;
        z-index: 1;
        background-color: #fff;
        padding-left: 3px;
        white-space: nowrap;
        margin-left: 25px;
        label {
          font-size: 14px;
          line-height: 1.57;
          color: #666666;
          display: inline-block;
          cursor: pointer;
          //&.right {
          //  margin-left: 25px;
          //}
          .icon {
            vertical-align: middle;
            margin-top: -2px;
          }
        }
      }
      .content__desc {
        display: inline-block;
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        margin-left: 10px;
      }
      .tooltip {
        float: left;
        padding-top: 2px;
      }
    }
    .input--wrap {
      text-align: left;
      margin-top: 35px;
      &.css {
        margin-top: 0px;
      }
      .url--desc {
        margin-left: -13px;
        margin-top: 10px;
        display: inline-block;
        color: #767676;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px;
      }
      .input--wrap.above-input {
        margin-top: 0;
        width: 480px;
      }
    }
    .image--wrap {
      margin-top: 35px;
      .note {
        height: 105px;
        padding: 40px 20px;
        border-radius: 5px;
        background-color: #2F2F2F;
        position: relative;
        .title {
          top: 8px;
          left: 8px;
          position: absolute;
          padding: 4px 6px;
          color: #FFF;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 12px;
          background-color: #43B6C9;
          border-radius: 5px;
        }
        .tag--wrap {
          display: flex;
          justify-content: center;
          position: relative;
          .icon--arrow-small-right-gray {
            position: absolute;
            bottom: 8px;
          }
          .tag {
            text-align: left;
            .input {
              width: 98px;
              height: 32px;
              color: #2F2F2F;
              background-color: #fff;
              padding: 0 11px;
              line-height: 32px;
              text-align: left;
              border-radius: 5px;
              margin-top: 3px;
            }
            .label {
              color: #D7D7D7;
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: 17px;
              margin: 0 0 0 5px;
            }
            &.right {
              margin-left: 35px;
            }
          }
        }
        .desc--wrap {
          padding-top: 15px;
          .main {
            display: inline-block;
            color: #FFF;
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 19px;
          }
          .sub {
            display: inline-block;
            color: #D7D7D7;
            text-align: center;
            font-size: 11px;
            font-style: normal;
            font-weight: 400;
            line-height: 19px;
          }
        }
      }
    }
  }
  .buttons {
    padding-top: 70px;
    text-align: center;
    .ui-btn {
      min-width: 90px;
    }
  }
}
</style>
